import Vue from 'vue';
import VueRouter from 'vue-router';
import { getToken } from "@/utils/auth";
Vue.use(VueRouter);

const routeList = [
  {
    path: '/home',
    component: () => import('../views/index'),
    meta: { title: '首页', activeMenu: '/home', expand: false, icon: 'el-icon-s-home' },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('../views/home'),
        meta: { title: '首页', activeMenu: '/home' },
      },
    ]
  },
  {
    path: '/project',
    component: () => import('../views/index.vue'),
    meta: { title: '项目管理', activeMenu: '/project', expand: false, icon: 'el-icon-s-grid' },
    children: [
      {
        path: '',
        name: 'project',
        component: () => import('../views/project'),
        meta: { title: '项目列表', activeMenu: '/project', icon: 'el-icon-s-grid' },
      },
      {
        path: 'project-detail',
        name: 'projectDetail',
        component: () => import('../views/projectDetail'),
        meta: { title: '项目配置', activeMenu: '/project-detail', icon: 'el-icon-s-tools' },
      },



    ]
  },
  {
    path: '/system',
    name: 'system',
    component: () => import('../views/index'),
    meta: { title: '系统设置', activeMenu: '/system', expand: true, icon: 'el-icon-s-platform' },
    children: [
      {
        path: 'manager',
        name: 'systemManager',
        component: () => import('../views/system/manager'),
        meta: { title: '系统管理员', activeMenu: '/system/manager', icon: 'el-icon-s-custom' },
      },
      {
        path: 'log',
        name: 'systemLog',
        component: () => import('../views/system/log'),
        meta: { title: '系统日志', activeMenu: '/system/log', icon: 'el-icon-s-order' },
      },

    ]
  },
  {
    path: '/operation',
    name: 'operation',
    component: () => import('../views/index'),
    meta: { title: '运营管理', activeMenu: '/operation', expand: true, icon: 'el-icon-s-marketing' },
    children: [
      {
        path: 'agency',
        name: 'operationAgency',
        component: () => import('../views/operation/agency'),
        meta: { title: '机构信息管理', activeMenu: '/operation/agency', icon: 'el-icon-s-data' },
      },
      {
        path: 'agency-manager',
        name: 'operationAgencyManager',
        component: () => import('../views/operation/agency-manager'),
        meta: { title: '机构管理员', activeMenu: '/operation/agency-manager', icon: 'el-icon-s-custom' },
      },
      {
        path: 'agency-log',
        name: 'operationAgencyLog',
        component: () => import('../views/operation/agency-log'),
        meta: { title: '机构日志管理', activeMenu: '/operation/agency-log', icon: 'el-icon-s-order' },
      },
      {
        path: 'robot',
        name: 'operationRobot',
        component: () => import('../views/operation/robot'),
        meta: { title: '机器人管理', activeMenu: '/operation/robot', icon: 'el-icon-receiving' },
      },
      {
        path: 'app',
        name: 'operationApp',
        component: () => import('../views/operation/app'),
        meta: { title: 'App版本控制', activeMenu: '/operation/app', icon: 'el-icon-receiving' },
      },
      {
        path: 'notice',
        name: 'operationNotice',
        component: () => import('../views/operation/notice'),
        meta: { title: '通知公告', activeMenu: '/operation/notice', icon: 'el-icon-receiving' },
      },



    ]
  },
]

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: { title: '登录', activeMenu: '/login' },
  },
  ...routeList

]




const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// 路由拦截
router.beforeEach((to, from, next) => {
  // 所以一定要加to.path !== 'login'的判断
  if (to.path !== '/login') {
    if (getToken()) {
      next();
    } else {
      next('/login')
    }
  } else {
    next()
  }
});
export default { router, routeList }
